import { Component } from "@angular/core";
import { EntryService } from "src/app/services/entry.service";
import { ActivatedRoute } from "@angular/router";
import { IEntryProjekteItem } from "src/rest-interfaces/projekte/IEntryProjekte";
import { LocaleService } from "../../localization/locale.service";
import { ILocalizedComponent } from "src/app/ILocalizedComponent";
import { Title, DomSanitizer } from "@angular/platform-browser";
import { generalAnimations } from "src/app/_animations/general.animations";
import { SliderConfigService } from "src/app/services/slider-config.service";
import { EProjectContact } from "src/rest-interfaces/EProjectContact";
import { LightboxService } from "src/app/services/lightbox.service";

@Component({
  selector: "app-projekte-item",
  templateUrl: "./projekte-item.component.html",
  animations: [generalAnimations],
})
export class ProjekteItemComponent implements ILocalizedComponent {
  public content: IEntryProjekteItem;
  public EProjectContact = EProjectContact;
  public currentSlide: number = 0;
  public projectSliderConfig: any;
  public milestoneSliderConfig: any;
  public milestoneMobileSliderConfig: any;
  private MilestoneCategory = "meilensteinprojekte";

  public get isMilestone(): boolean {
    const _isMilestone =
      this.content &&
      this.content.projektKategorie &&
      this.content.projektKategorie.hasOwnProperty(this.MilestoneCategory);
    return _isMilestone;
  }

  public getMilestoneText(_m: { blocktype: string }): string {
    const milestone = this.content.milestones.find(
      (m) => m.blocktype === _m.blocktype
    );
    return milestone ? milestone.richText : null;
  }

  constructor(
    private entrySvc: EntryService,
    private localeSvc: LocaleService,
    private route: ActivatedRoute,
    private title: Title,
    public SliderConfigSvc: SliderConfigService,
    public lightboxSvc: LightboxService,
    private sanitizer: DomSanitizer
  ) {
    this.projectSliderConfig = {
      ...this.SliderConfigSvc.HauptbildSlider,
      appendArrows: ".project-main-slider-arrows",
    };
    this.milestoneSliderConfig = {
      ...this.SliderConfigSvc.HauptbildSlider,
      appendArrows: ".project-milestone-slider-arrows",
    };
    this.milestoneMobileSliderConfig = {
      ...this.SliderConfigSvc.HauptbildSlider,
      appendArrows: ".project-milestone-mobile-slider-arrows",
    };

    this.route.url.subscribe(() => {
      this.entrySvc
        .customControllerUri<IEntryProjekteItem>(this.localeSvc.RouterUri)
        .subscribe(
          (t) => {
            if (Array.isArray(t.projektZusatzinfos)) {
              t.projektZusatzinfos = t.projektZusatzinfos.map((info) => {
                if (info.text) {
                  info.text = this.sanitizer.bypassSecurityTrustHtml(
                    (info.text as string).replace(/\n/g, "<br>\n")
                  );
                }
                return info;
              });
            }

            this.content = t;
            this.title.setTitle(
              "PIRMIN JUNG - " +
                (typeof t.metaTitle === "string" && t.metaTitle.length > 0
                  ? t.metaTitle
                  : t.title)
            );
          },
          () => {
            this.localeSvc.navigateToHome();
          }
        );
    });
  }

  public getLocaleChangeUrl(targetLocale: string): string {
    const locUrlProperty = "url_" + targetLocale;
    if (this.content && this.content.hasOwnProperty(locUrlProperty)) {
      return this.content[locUrlProperty];
    }
  }

  public afterChange(event: Event) {
    this.currentSlide = (event as any).currentSlide;
  }

  public showInLightBox(bilder) {
    this.lightboxSvc.setLightboxContent(bilder, this.currentSlide);
  }

  public getMilestoneZahlenByBlocktype(blocktype: string) {
    let searchedMilestone = this.content.milestoneZahlenUndFakten.filter(
      (milestone) => {
        return milestone.blocktype === blocktype;
      }
    );

    if (searchedMilestone.length > 0) {
      return searchedMilestone[0];
    } else {
      return null;
    }
  }

  public getMilestoneTextByBlocktype(blocktype: string) {
    let searchedMilestone = this.content.milestones.filter((milestone) => {
      return milestone.blocktype === blocktype;
    });

    if (searchedMilestone.length > 0) {
      return searchedMilestone[0];
    } else {
      return null;
    }
  }
}
